<template>
  <v-row no-gutters>
    <v-col cols="8" style="max-width: 17vw">
      <v-tooltip bottom color="font">
        <template #activator="{ on }">
          <div v-on="on" class="text-truncate pa-0 text-left text-subtitle-2" style="font-size: 12px !important;">
            {{ docCopy.document_name }}
          </div>
        </template>
        {{ docCopy.document_name }}
      </v-tooltip>
      <v-tooltip bottom color="font">
        <template #activator="{ on }">
          <div class="text-left text-truncate text-caption font-italic font-weight-light pa-0" v-on="on">
            {{ docCopy.subheader }}
          </div>
        </template>
        {{ docCopy.subheader }}
      </v-tooltip>
    </v-col>
    <v-spacer />
    <v-col cols="auto">
      <v-tooltip bottom color="font">
        <template #activator="{ on }">
          <span v-on="on">
            <main-loader v-if="docCopy.isDownloading" size="24" />
            <v-btn icon @click="setDownloading(docCopy)" v-else>
              <v-icon> mdi-download </v-icon>
            </v-btn>
          </span>
        </template>
        {{ $i18n.t('menu.downloadDocument') }}
      </v-tooltip>
    </v-col>
    <v-col cols="auto">
      <dots-menu
        @changeName="$emit('changeDocumentName', { id: docCopy.document_id, name: docCopy.document_name })"
        @delete="$emit('deleteDocument', { id: docCopy.document_id, name: docCopy.document_name })"
        :items="dotsItems"
      ></dots-menu>
    </v-col>
  </v-row>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';
import MainLoader from '@/components/MainLoader';
import { cloneDeep } from 'lodash';

export default {
  name: 'DocumentRow',
  components: { MainLoader, DotsMenu },
  props: {
    doc: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    dotsItems: [{ name: 'changeName' }, { name: 'delete' }],
    docCopy: {},
  }),
  methods: {
    setDownloading(doc) {
      this.$emit('downloadDocument', doc.document_id);
      this.docCopy.isDownloading = true;
    },
    finishDownload() {
      this.docCopy.isDownloading = false;
    },
  },
  mounted() {
    this.docCopy = cloneDeep(this.doc);
  },
};
</script>

<style scoped></style>
